import React, { useEffect, useState } from 'react';
import '../CSS/Highlights.css';

const REPORT_TYPE = 'Security Planning'; // what gets written to SharePoint

function logSecurityClick(reportName, reportType = REPORT_TYPE) {
  const userEmail = localStorage.getItem('user-email');
  if (!userEmail) return;

  const payload = { reportName, reportType, userEmail };

  try {
    if (navigator.sendBeacon) {
      const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
      navigator.sendBeacon('/api/log-report', blob);
    } else {
      fetch('/api/log-report', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
        body: JSON.stringify(payload),
      }).catch(() => {});
    }
  } catch {}
}

const Highlights = () => {
  const [SecurityPlanning, setSecurityPlanning] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);

  const addProxyUrls = (items) =>
    (items || []).map((item) => ({
      ...item,
      proxyUrl: `/api/highlights/SecurityPlanning/${encodeURIComponent(item.name)}.pdf`,
    }));

  useEffect(() => {
    let mounted = true;
    fetch('/api/hello')
      .then((r) => r.json())
      .then((data) => {
        if (!mounted) return;
        const withProxy = addProxyUrls(data?.SecurityPlanning || []);
        setSecurityPlanning(withProxy);
        setFilteredData(withProxy);
      })
      .catch((err) => console.error('Error fetching reports data:', err))
      .finally(() => mounted && setLoading(false));

    return () => {
      mounted = false;
    };
  }, []);

  const handleSearch = (e) => {
    const term = e.target.value;
    setSearchTerm(term);

    if (term.trim()) {
      const t = term.toLowerCase();
      setFilteredData(
        SecurityPlanning.filter((item) =>
          item.name?.toLowerCase().includes(t)
        )
      );
    } else {
      setFilteredData(SecurityPlanning);
    }
  };

  if (loading) {
    return (
      <div className="highlights">
        <h1>Security Planning</h1>
        <p>Loading…</p>
      </div>
    );
  }

  return (
    <div className="highlights">
      <h1>Security Planning</h1>

      <div className="box">
        <p>
          Comprehensive intelligence reports offering expanded insights, directions, and guidance
          to mitigate potential security risks and address emerging threats, ensuring a proactive
          approach to security management.
        </p>
      </div>

      {/* ✅ EXACT SAME SEARCH SETUP AS OTHER PAGES */}
      <label className="highlights-search">
        Search:&nbsp;
        <input
          type="text"
          placeholder="Search by title"
          value={searchTerm}
          onChange={handleSearch}
        />
      </label>

      <ul className="list-item">
        {filteredData.map((item, index) => (
          <li key={item.id || index}>
            <a
              href={item.proxyUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                const cleanName = (item.name || '').replace(/\.pdf$/i, '');
                logSecurityClick(cleanName);
              }}
            >
              {item.name}
            </a>
          </li>
        ))}
      </ul>

      {filteredData.length === 0 && <p>No reports found.</p>}
    </div>
  );
};

export default Highlights;
